<section class="record-view-card" [class.record-view-card--gray]="useGrayTheme">
  <header class="record-view-header">
    <div class="record-view-header-left">
      <h2
        class="record-view-title"
        [id]="prefix + '_title_value'"
        [attr.data-pw]="prefix + '_title_value'"
        [attr.data-qa]="prefix + '_title_value'"
        [attr.aria-label]="title">
        {{ title }}
      </h2>
      <div class="record-view-meta">
        <span
          class="record-view-meta-label"
          [attr.aria-label]="headerMetaLabel"
          [id]="prefix + '_header_meta_label'"
          [attr.data-pw]="prefix + '_header_meta_label'"
          [attr.data-qa]="prefix + '_header_meta_label'">
          {{ headerMetaLabel }}
        </span>
        <span
          class="record-view-meta-value"
          [id]="prefix + '_header_meta_value'"
          [attr.data-pw]="prefix + '_header_meta_value'"
          [attr.data-qa]="prefix + '_header_meta_value'">
          {{ headerMetaValue }}
        </span>
      </div>
    </div>

    @if (showInitiateTransferButton || showChangeGuardianButton || showResendAwardOfferButton || showExitButton || showEmptyState || canEdit || showPrintButton) {
      <div class="record-view-actions">
        @if (showInitiateTransferButton) {
          <button
            class="primary_materials_button record-view-initiate-transfer-button"
            type="button"
            (click)="initiateTransfer.emit()"
            [id]="prefix + '_initiate_transfer_button'"
            [attr.data-pw]="prefix + '_initiate_transfer_button'"
            [attr.data-qa]="prefix + '_initiate_transfer_button'">
            {{ initiateTransferButtonText }}
          </button>
        }

        @if (showChangeGuardianButton) {
          <button
            class="primary_materials_button record-view-change-guardian-button"
            type="button"
            (click)="changeGuardian.emit()"
            [id]="prefix + '_change_guardian_button'"
            [attr.data-pw]="prefix + '_change_guardian_button'"
            [attr.data-qa]="prefix + '_change_guardian_button'">
            {{ changeGuardianButtonText }}
          </button>
        }

        @if (showResendAwardOfferButton) {
          <button
            class="primary_materials_button record-view-resend-award-offer-button"
            type="button"
            (click)="resendAwardOffer.emit()"
            [id]="prefix + '_resend_award_offer_button'"
            [attr.aria-label]="resendAwardOfferButtonText + ' for ' + title"
            [attr.data-pw]="prefix + '_resend_award_offer_button'"
            [attr.data-qa]="prefix + '_resend_award_offer_button'">
            {{ resendAwardOfferButtonText }}
          </button>
        }

        @if (showExitButton) {
          <button
            class="primary_materials_button record-view-exit-button"
            type="button"
            (click)="exit.emit()"
            [id]="prefix + '_exit_button'"
            [attr.aria-label]="exitButtonText + ' ' + title"
            [attr.data-pw]="prefix + '_exit_button'"
            [attr.data-qa]="prefix + '_exit_button'">
            {{ exitButtonText }}
          </button>
        }

        @if (showEmptyState) {
          <button
            class="primary_materials_button record-view-empty-state-button"
            type="button"
            mat-button
            [disabled]="emptyStateButtonDisabled"
            (click)="emptyStateApply.emit()"
            [id]="prefix + '_empty_state_button'"
            [attr.data-pw]="prefix + '_empty_state_button'"
            [attr.data-qa]="prefix + '_empty_state_button'">
            {{ emptyStateButtonText }}
          </button>
        }
        <ng-content />
        @if (canEdit) {
          <button
            class="record-view-edit-button"
            type="button"
            (click)="edit.emit()"
            [id]="prefix + '_edit_button'"
            [attr.aria-label]="'Edit ' + title"
            [attr.data-pw]="prefix + '_edit_button'"
            [attr.data-qa]="prefix + '_edit_button'">
            <mat-icon svgIcon="k12-edit" />
            Edit
          </button>
        }
        @if (showPrintButton) {
          <button
            class="primary_materials_button record-view-print-button"
            type="button"
            (click)="print.emit()"
            [id]="prefix + '_print_button'"
            [attr.aria-label]="printButtonText + ' ' + title"
            [attr.data-pw]="prefix + '_print_button'"
            [attr.data-qa]="prefix + '_print_button'">
            <mat-icon aria-hidden="true">print</mat-icon>
            {{ printButtonText }}
          </button>
        }
      </div>
    }
  </header>

  <div class="record-view-body">
      @if (showEmptyState) {
        <div class="record-view-grid" [style.--sd-columns]="1">
          <div class="record-view-empty-state">
            <p>No information available.</p>
          </div>
        </div>
      }
      @else {
        <div class="record-view-grid" [style.--sd-columns]="columns">
          @for (section of sections; track trackBySection($index, section)) {
            <div class="record-view-col">
              <h3
                class="record-view-col-header"
                [attr.aria-label]="section.title"
                [id]="prefix + '_' + section.title + '_title'"
                [attr.data-pw]="prefix + '_' + section.title + '_title'"
                [attr.data-qa]="prefix + '_' + section.title + '_title'">
                {{ section.title }}
              </h3>
              @for (field of section.fields; track trackByField($index, field)) {
                @if (isVisible(field)) {
                  <div class="record-view-cell">
                    <span
                      class="record-view-label"
                      [attr.aria-label]="field.label"
                      [id]="prefix + '_' + field.label + '_label'"
                      [attr.data-pw]="prefix + '_' + field.label + '_label'"
                      [attr.data-qa]="prefix + '_' + field.label + '_label'"
                      >{{ field.label }}</span
                    >
                    <span
                      class="record-view-value"
                      [id]="prefix + '_' + field.key + '_value'"
                      [attr.data-pw]="prefix + '_' + field.key + '_value'"
                      [attr.data-qa]="prefix + '_' + field.key + '_value'">
                      {{ displayValue(field) }}
                    </span>
                  </div>
                }
              }
            </div>
          }
        </div>
      }
    </div>
</section>
